module.exports = __webpack_public_path__ + "img/fly-talks.10f49596.svg";